import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Iterator from '../../../../java/util/Iterator';
import NoSuchElementException from '../../../../java/util/NoSuchElementException';
import GeometryCollection from './GeometryCollection';
import UnsupportedOperationException from '../../../../java/lang/UnsupportedOperationException';
var GeometryCollectionIterator = /*#__PURE__*/function () {
  function GeometryCollectionIterator() {
    _classCallCheck(this, GeometryCollectionIterator);
    GeometryCollectionIterator.constructor_.apply(this, arguments);
  }
  _createClass(GeometryCollectionIterator, [{
    key: "next",
    value: function next() {
      if (this._atStart) {
        this._atStart = false;
        if (GeometryCollectionIterator.isAtomic(this._parent)) this._index++;
        return this._parent;
      }
      if (this._subcollectionIterator !== null) if (this._subcollectionIterator.hasNext()) return this._subcollectionIterator.next();else this._subcollectionIterator = null;
      if (this._index >= this._max) throw new NoSuchElementException();
      var obj = this._parent.getGeometryN(this._index++);
      if (obj instanceof GeometryCollection) {
        this._subcollectionIterator = new GeometryCollectionIterator(obj);
        return this._subcollectionIterator.next();
      }
      return obj;
    }
  }, {
    key: "remove",
    value: function remove() {
      throw new UnsupportedOperationException(this.getClass().getName());
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this._atStart) return true;
      if (this._subcollectionIterator !== null) {
        if (this._subcollectionIterator.hasNext()) return true;
        this._subcollectionIterator = null;
      }
      if (this._index >= this._max) return false;
      return true;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Iterator];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._parent = null;
      this._atStart = null;
      this._max = null;
      this._index = null;
      this._subcollectionIterator = null;
      var parent = arguments[0];
      this._parent = parent;
      this._atStart = true;
      this._index = 0;
      this._max = parent.getNumGeometries();
    }
  }, {
    key: "isAtomic",
    value: function isAtomic(geom) {
      return !(geom instanceof GeometryCollection);
    }
  }]);
  return GeometryCollectionIterator;
}();
export { GeometryCollectionIterator as default };